import React, {useEffect} from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import Main from '@modules/main/Main';
import Login from '@modules/login/Login';
import Logout from '@modules/login/Logout';
// import Test from '@app/pages/report/Test';
// import Register from '@modules/register/Register';
// import ForgetPassword from '@modules/forgot-password/ForgotPassword';
// import RecoverPassword from '@modules/recover-password/RecoverPassword';
import {useWindowSize} from '@app/hooks/useWindowSize';
import {calculateWindowSize} from '@app/utils/helpers';
import {useDispatch, useSelector} from 'react-redux';
import {setWindowSize} from '@app/store/reducers/ui';

import Dashboard from '@pages/DashboardContainer';
import Blank from '@pages/Blank';
// import SubMenu from '@pages/SubMenu';
import Profile from '@pages/profile/Profile';

import Report from '@pages/Report';
import Manage from '@pages/Manage';
import Users from '@pages/Users';
import Sms from '@pages/Sms';
import Smslog from '@pages/Smslog';
import Qr from '@pages/Qr';
import Checker from '@pages/Checker';
import Zoom from '@pages/Zoom';

import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';

import MakeTrip from '@app/pages/car/MakeTrip';
import Approve from '@app/pages/car/Approve';
import Me from '@app/pages/car/Manage';
import Cr from '@app/pages/car/Cr';
import ReportCr from '@app/pages/car/Report';
import Driver from '@app/pages/car/Driver';
import Costcenter from '@app/pages/car/Costcenter';

import Calendar from '@app/pages/car/Calendar';

import Blank2 from '@app/pages/car/Blank';

//HRD
import TrainingMake from '@app/pages/hrd/TrainingMake';
import TrainingPermission from '@app/pages/hrd/TrainingPermission';
import TrainingReport from '@app/pages/hrd/TrainingReport';
import TrainingAll from '@app/pages/hrd/TrainingAll';

import Registershop from '@app/pages/fastprint/Registershop';
import RenewShop from '@app/pages/fastprint/RenewShop';
import MyItems from '@app/pages/fastprint/MyItems';
import MyItemsAdmin from '@app/pages/fastprint/MyItemsAdmin';
import Contract from '@app/pages/fastprint/Contract';
import MyItemsAccountant from '@app/pages/fastprint/MyItemsAccountant';
import SurveyVn from '@pages/SurveyVn';
import DrivingLicense from '@app/pages/hrd/DrivingLicense';

//Cds
import AddShopCds from './pages/cds-v2/AddShopCds';
import AddVisitCds from './pages/cds-v2/AddVisitCds';

const App = () => {
  const windowSize = useWindowSize();
  const screenSize = useSelector((state: any) => state.ui.screenSize);
  const dispatch = useDispatch();

  useEffect(() => {
    const size = calculateWindowSize(windowSize.width);
    if (screenSize !== size) {
      dispatch(setWindowSize(size));
    }
  }, [windowSize]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<PublicRoute />}>
          <Route path="/login" element={<Login />} />
        </Route>
        <Route path="/hrd-license/:empid" element={<DrivingLicense />} />

        {/* <Route path="/logout" element={<PublicRoute />}> */}
        <Route path="/logout" element={<Logout />} />
        {/* <Route path="/test" element={<Test />} /> */}
        {/* </Route> */}
        {/* <Route path="/register" element={<PublicRoute />}>
          <Route path="/register" element={<Register />} />
        </Route> */}
        {/* <Route path="/forgot-password" element={<PublicRoute />}>
          <Route path="/forgot-password" element={<ForgetPassword />} />
        </Route> */}
        {/* <Route path="/recover-password" element={<PublicRoute />}>
          <Route path="/recover-password" element={<RecoverPassword />} />
        </Route> */}
        <Route path="/menu" element={<Blank />} />
        <Route path="/survey-vn" element={<SurveyVn />} />
        <Route path="/" element={<PrivateRoute />}>
          <Route path="/" element={<Main />}>
            {/* <Route path="/sub-menu-2" element={<Blank />} /> */}
            {/* <Route path="/sub-menu-1" element={<SubMenu />} /> */}
            {/* <Route path="/blank" element={<Blank />} /> */}
            <Route path="/qr-dashboard" element={<Dashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/qr-manage" element={<Manage />} />
            <Route path="/qr-sms" element={<Sms />} />
            <Route path="/qr-users" element={<Users />} />
            <Route path="/qr-smslog" element={<Smslog />} />
            <Route path="/qr-report" element={<Report />} />
            <Route path="/qr-qr" element={<Qr />} />
            <Route path="/qr-checker" element={<Checker />} />
            <Route path="/" element={<MakeTrip />} />
            <Route path="/trip-make" element={<MakeTrip />} />
            {/* <Route path="/trip-make" element={<Blank2 />} /> */}
            <Route path="/trip-approve" element={<Approve />} />
            <Route path="/trip-me" element={<Me />} />
            <Route path="/trip-costcenter" element={<Costcenter />} />
            <Route path="/trip-calendar" element={<Calendar />} />
            <Route path="/trip-cr" element={<Cr />} />
            <Route path="/trip-report" element={<ReportCr />} />
            <Route path="/trip-driver" element={<Driver />} />

            <Route path="/hrd-make" element={<TrainingMake />} />
            <Route
              path="/hrd-make/copy/:id/:report_id"
              element={<TrainingMake />}
            />
            <Route path="/hrd-permission" element={<TrainingPermission />} />
            <Route path="/hrd-report" element={<TrainingReport />} />
            <Route path="/hrd-all" element={<TrainingAll />} />

            <Route path="/fp-new" element={<Registershop />} />
            <Route path="/fp-renew" element={<RenewShop />} />
            <Route path="/fp-me" element={<MyItems />} />
            <Route path="/fp-approve" element={<MyItemsAdmin />} />
            <Route path="/fp-contract" element={<Contract />} />
            <Route path="/fp-accounting" element={<MyItemsAccountant />} />

            <Route path="/cds-add-visit" element={<AddVisitCds />} />
            <Route path="/cds-add-shop" element={<AddShopCds />} />

            <Route path="/app-zoom" element={<Zoom />} />
          </Route>
        </Route>
      </Routes>
      <ToastContainer
        autoClose={3000}
        draggable={false}
        position="top-right"
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnHover
      />
    </BrowserRouter>
  );
};

export default App;
